import ConsumersScreen from "../modules/users/ConsumersScreen";

export default function Consumer() {
  return (
    <>
      <ConsumersScreen />
    </>
  )
}
